module.exports = __webpack_public_path__ + "media/images/admin/icons/align-center-c9a0a09d9a713f6e2e7537766e5bb18b.svg";